export const ADD_TOAST = 'TOASTS_ADD_TOAST'
export const RESET_TOAST = 'TOASTS_RESET_TOAST'

export const addToast = (data) => {
  return { type: ADD_TOAST, data: data }
}

export const resetToast = () => {
  return { type: RESET_TOAST }
}
